import { Alert, Link, Spinner } from '@amzn/awsui-components-react';

import { constants } from '../../../common/Localization';
import AWSCATTable from '../../../common/table/Table-index';
import { ColumnDefinition } from '../../../common/table/types';

interface Props<T> {
    resourceName: string;
    items: T[];
    columnDefinitions: ColumnDefinition<T>[];
    onSelectionChange: (items: readonly T[] | undefined) => void;
    loading: boolean;
    href: string;
}

function ContactManagementOwnershipAssetTable<T>({ items, resourceName, columnDefinitions, onSelectionChange, loading, href }: Props<T>) {

    const getContent = () => {
        if (items.length === 0) {
            return (
                <Alert
                    header={constants.IMPORT_YOUR_DATA}
                >
                    {`${constants.IMPORT_DATA_MSG_P1} ${resourceName} ${constants.DATA}. 
                    ${constants.PLEASE_IMPORT} ${resourceName.toLowerCase()} ${constants.DATA_ON_THE} `}
                    <Link href={href}>{resourceName}</Link> {`${constants.PAGE}.`}
                </Alert>
            );
        } else {
            return (
                <AWSCATTable
                    resourceName={resourceName}
                    items={items}
                    columnDefinitions={columnDefinitions}
                    loading={loading}
                    selectionType='multi'
                    onSelectionChange={onSelectionChange}
                    autoGenerateVisibleContent
                    useDefaultDownload
                    resizeable
                />
            );
        }
    };
    return loading ? <Spinner size='large'/> : getContent();
}

export default ContactManagementOwnershipAssetTable;
